export default {
	id: "pixel",
	title: "Pixel",
	company: "Google",
	borderRadius: "0.1em",
	colorSide: true,
	styles: [
		{
			title: "normal",
			pos: ["10%", "6%", "11.5%", "6%"],
			colors: [
				{
					title: "Silver",
					hex: "#D5D2CF",
					img: require("./original/silver.png")
				},
				{title: "Blue", hex: "#1626C5", img: require("./original/blue.png")},
				{title: "Black", hex: "#000000", img: require("./original/black.png")}
			]
		}
	]
};
